import React from 'react';
import { Box, Typography } from '@mui/material';
import { alpha } from '@mui/material/styles';

export const FLOATING_FIELD_HEIGHT = 40;

/**
 * Renders the label inside the field while empty and docks it to the top border once
 * the control holds a value or is open, matching the Marmin floating-label field spec.
 */
const FloatingFieldShell = ({
  label,
  floated = false,
  active = false,
  error = false,
  required = false,
  disabled = false,
  sx,
  children,
}) => {
  const resolvedBorderColor = error ? 'error.main' : active ? 'primary.main' : 'divider';

  return (
    <Box sx={{ minWidth: 120, ...sx }}>
      <Box
        sx={{
          position: 'relative',
          height: FLOATING_FIELD_HEIGHT,
          borderRadius: 1,
          border: '1px solid',
          borderColor: resolvedBorderColor,
          bgcolor: 'background.paper',
          opacity: disabled ? 0.6 : 1,
          transition: 'border-color 150ms ease, box-shadow 150ms ease',
          boxShadow: active ? (theme) => `0 0 0 1px ${alpha(theme.palette.primary.main, 0.3)}` : 'none',
          '&:hover': {
            borderColor: disabled || error || active ? resolvedBorderColor : 'text.disabled',
          },
        }}
      >
        <Typography
          component="label"
          sx={{
            position: 'absolute',
            left: 8,
            zIndex: 1,
            px: 0.5,
            maxWidth: 'calc(100% - 16px)',
            bgcolor: 'background.paper',
            pointerEvents: 'none',
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            transition: 'all 150ms ease',
            color: error ? 'error.main' : active ? 'primary.main' : 'text.secondary',
            ...(floated
              ? { top: -8, fontSize: 10, lineHeight: 1 }
              : { top: '50%', transform: 'translateY(-50%)', fontSize: 12, lineHeight: 1 }),
          }}
        >
          {label}
          {required && (
            <Box component="span" sx={{ color: 'error.main', ml: 0.25 }}>
              *
            </Box>
          )}
        </Typography>

        <Box sx={{ display: 'flex', alignItems: 'center', height: '100%' }}>{children}</Box>
      </Box>
    </Box>
  );
};

export default FloatingFieldShell;
